import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableTradeService {
  customerApi: string;
  identityApi: string;
  constructor(private http: HttpClient) {
    this.customerApi = environment.customerApiUrl;
  }
  public getTradeByState(body): Observable<any> {
    return this.http.post(`${this.customerApi}/trade/get-trade-history-by-state`, body);
  }
  public exportExcel(body): Observable<any> {
    return this.http.post(`${this.customerApi}/trade/export-excel-trade-history`, body, { responseType: 'blob' });
  }
  public downloadPDF(params): Observable<any> {
    return this.http.post(`${this.customerApi}/trade/show-pdf`, params, { responseType: 'blob' });
  }
  public getTradeModification(id): Observable<any> {
    return this.http.get(`${this.customerApi}/trade/get-trade-detail-by-parent/${id}`);
  }
  public getTradeByCurrency(body): Observable<any> {
    return this.http.post(`${this.customerApi}/trade/get-trade-history-by-currency`, body);
  }
}
